import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* mailDraftListGet(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/mailDraftListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MAIL_DRAFT_LIST_SET",
        payload: {
          list: res.data.list,
          page: action.payload.page,
          isList: res.data.isList,
          isListNext: res.data.isListNext,
        },
      });
    }
  }

  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}

function* mailDraftSave(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'save');
    params.append('pic', payload.pic);
    params.append('mailText', payload.mailText);
    return axios.post(config.apiUri + "member/mailDraftEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MAIL_DRAFT_ITEM_SET",
        payload: {
          type: res.data.type,
          pic: action.payload.pic,
          mailText: action.payload.mailText,
        },
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'メールを下書き保存しました'} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}

function* mailDraftDel(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('delList', payload.delList);
    return axios.post(config.apiUri + "member/mailDraftDelApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}

function* mailDraftItemGet(action) {

  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/mailDraftApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

}

const saga = [
  takeLatest('MAIL_DRAFT_LIST_GET', mailDraftListGet),
  takeLatest('MAIL_DRAFT_ITEM_GET', mailDraftItemGet),
  takeLatest('MAIL_DRAFT_SAVE', mailDraftSave),
  takeLatest('MAIL_DRAFT_DEL', mailDraftDel),
];

export default saga;
